<template>
  <div id="indicator" class="progress"></div>
</template>
<script>
export default {
  name: "br-indicator",
  mounted: function() {
    var vm = this;
    window.addEventListener("scroll", function() {
      var scrollPos = window.scrollY;
      var winHeight = window.innerHeight;
      var docHeight = document.documentElement.scrollHeight; // instead document.body.clientHeight
      var perc = (100 * scrollPos) / (docHeight - winHeight);
      vm.$el.style.width = perc + "%";
    });
  },
};
</script>

<style lang="css" scoped>
.progress {
  height: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 0;
  background-color: #feb40f;
}
</style>
